var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { Skeleton } from "@mui/lab";
import clsx from "clsx";
import { useStyles } from "./ui_skeleton.css";
export const UiSkeleton = (_a) => {
    var { children, fullWidth, m, variant, width } = _a, props = __rest(_a, ["children", "fullWidth", "m", "variant", "width"]);
    const classes = useStyles({ m });
    return (_jsx(Skeleton, Object.assign({}, props, { className: clsx(classes.ui_skeleton, {
            [classes.ui_skeleton__variant_card]: variant === "card",
        }), variant: variant === "card" ? "rectangular" : variant, width: fullWidth ? "100%" : width, children: children })));
};
//# sourceMappingURL=ui_skeleton.js.map